<template>
  <div class="motherAndInfant">
    <Header />
    <div class="banner">
      <div class="title">
        母婴行业解决方案
      </div>
      <div class="title__tips">
        针对母婴行业的供应商、门店、会员等问题，提出解决方案，助力母婴新零售发展
      </div>
      <div class="btn__box">
        <span class="btn-detail" @click="linkTo('/register')">
          免费试用
        </span>
      </div>
    </div>
    <div id="navagation" class="navagation">
      <div class="content content__box" :class="{ isFixed: isFixed }">
        <div class="nav__item"><a href="#framework">方案构架</a></div>
        <div class="nav__item"><a href="#Business">业务场景</a></div>
        <div class="nav__item"><a href="#Customer">客户案例</a></div>
      </div>
    </div>
    <div id="framework"></div>
    <div class="product">
      <div class="content content__box">
        <div class="product__title">方案构架</div>
        <div class="product__detail"></div>
      </div>
    </div>
    <div id="Business"></div>
    <div class="scene">
      <div class="content scene__box">
        <div class="scene__title">业务场景</div>
        <div class="scene__detail">
          <div class="left">
            <div class="item">
              <div
                class="text"
                @click="setSceneActive(0)"
                :class="{ 'text-active': sceneActive === 0 }"
              >
                忠实顾客少
              </div>
            </div>
            <div class="item">
              <div
                class="text"
                @click="setSceneActive(1)"
                :class="{ 'text-active': sceneActive === 1 }"
              >
                获客能力不足
              </div>
            </div>
            <div class="item">
              <div
                class="text"
                @click="setSceneActive(2)"
                :class="{ 'text-active': sceneActive === 2 }"
              >
                门店导购平均年龄偏大
              </div>
            </div>
            <div class="item">
              <div
                class="text"
                @click="setSceneActive(3)"
                :class="{ 'text-active': sceneActive === 3 }"
              >
                业务数据混杂
              </div>
            </div>
            <div class="item"></div>
          </div>
          <div class="right">
            <template v-for="(item, index) in sceneDetailList">
              <div class="item" v-if="index === sceneActive" :key="index">
                <div class="name">{{ item.name }}</div>
                <div class="qAndp">
                  <div class="qbox">
                    <div class="qtitle">问题详解</div>
                    <ul>
                      <li
                        class="qitem"
                        v-for="(qitem, qindex) in item.qbox.items"
                        :key="index + '' + qindex"
                      >
                        {{ qitem }}
                      </li>
                    </ul>
                  </div>
                  <div class="pbox">
                    <div class="ptitle">对应解决方案</div>
                    <ul>
                      <li
                        class="pitem"
                        v-for="(pitem, pindex) in item.pbox.items"
                        :key="index + '' + pindex"
                      >
                        {{ pitem }}
                      </li>
                    </ul>
                    <div class="pway">
                      {{ item.pway || " " }}
                    </div>
                    <div class="related">
                      <div class="related__item">相关产品</div>
                      <div
                        class="related__item"
                        v-for="(ritem, rindex) in item.pbox.relateds"
                        :key="index + '' + rindex"
                      >
                        <span :class="ritem.className + ' item__icon'"></span>
                        <span>{{ ritem.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div id="Customer"></div>
    <div class="advantage">
      <div class="content content__box">
        <div class="advantage__title">客户案例</div>
        <div class="advantage__detail">
          <div class="card">
            <el-carousel height="475px" :interval="5000" arrow="always">
              <el-carousel-item>
                <div class="card__bdground"></div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="card__bdground2"></div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  components: { Header, Footer },
  data() {
    return {
      isFixed: false,
      offsetTop: 506,
      sceneDetailList: [
        {
          name: "忠实顾客少",
          qbox: {
            title: "问题详解",
            items: [
              "随着孩子年龄变大，需求变更快速",
              "母婴针对群体年龄范围比较小"
            ]
          },
          pbox: {
            title: "对应解决方案",
            items: [
              "时刻智能跟进客户的孩子信息，智能预测下一次购买所需，提前推送营销活动",
              "根据客户的孩子基本信息、日常习惯等信息智能推送营销活动，以上两种方式提升客户的购买欲望，逐渐提高依赖度"
            ],
            pway: "以上两种方式提升客户的购买欲望，逐渐提高依赖度",
            relateds: [
              {
                className: "item__icon01",
                name: "CRM"
              },
              {
                className: "item__icon02",
                name: "云营销"
              }
            ]
          }
        },
        {
          name: "获客能力不足",
          qbox: {
            title: "问题详解",
            items: [
              "母婴行业针对客户的群体有限",
              "获客玩法有限，缺乏新玩法",
              "非标准化产品，用户体验标准不一，难以有效传达推广"
            ]
          },
          pbox: {
            title: "对应解决方案",
            items: [
              "通过公域精准定位母婴客群标签，推送邀请、获客的营销活动，引导拉新",
              "实时更新不同的裂变、邀请玩法，提供更多新玩法",
              "精准寻找KOL，提高KOL扩散活动传播"
            ],
            pway: "以上三种方式提高获客的精准度，提升获客能力。",
            relateds: [
              {
                className: "item__icon01",
                name: "CRM"
              },
              {
                className: "item__icon02",
                name: "云营销"
              }
            ]
          }
        },
        {
          name: "门店导购平均年龄偏大",
          qbox: {
            title: "问题详解",
            items: [
              "门店导购较多妈妈辈，销售水平非专业",
              "年龄偏大的导购学习能力一般"
            ]
          },
          pbox: {
            title: "对应解决方案",
            items: [
              "每个营销活动提供对应话术，让导购销售更加有说服力",
              "给导购提供母婴知识库，让导购学习更多母婴经验，提高能力",
              "营销活动转化为任务，提升导购的销售积极性"
            ],
            pway: "以上三种方式提高获客的精准度，提升获客能力。",
            relateds: [
              {
                className: "item__icon01",
                name: "导购助手"
              }
            ]
          }
        },
        {
          name: "业务数据混杂",
          qbox: {
            title: "问题详解",
            items: [
              "数据流失严重，过往数据精准度不高",
              "过往数据未能留存、运用，缺乏导流与识别潜客的技术手段"
            ]
          },
          pbox: {
            title: "对应解决方案",
            items: [
              "针对母婴进行会员的孩子信息分析",
              "针对各数据，提供导购、业绩、活动的分析"
            ],
            pway: "",
            relateds: [
              {
                className: "item__icon01",
                name: "导购助手"
              },
              {
                className: "item__icon02",
                name: "云营销"
              }
            ]
          }
        }
      ],
      sceneActive: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.watchScroll);
      this.offsetTop = document.querySelector("#navagation").offsetTop;
    });
  },
  methods: {
    watchScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    },
    setSceneActive(data) {
      this.sceneActive = data;
    },
    linkTo(url) {
      this.$router.push({
        path: url
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  }
};
</script>
<style lang="scss" scoped>
.motherAndInfant {
  .content {
    width: 1200px;
    margin: 0 auto;
    user-select: none;
  }
  .banner {
    box-sizing: border-box;
    height: 444px;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 100%;
    background-image: url("../../assets/img/programme/218@2x.png");
    .title {
      padding-top: 112px;
      font-size: 44px;
      font-weight: bold;
      line-height: 62px;
      color: rgba(255, 255, 255, 1);
    }
    .title__tips {
      margin-top: 24px;
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
      color: rgba(255, 255, 255, 1);
    }
    .btn__box {
      padding-top: 74px;
      .btn-detail {
        display: inline-block;
        text-align: center;
        width: 140px;
        height: 38px;
        border-radius: 19px;
        font-size: 14px;
        font-weight: 400;
        line-height: 38px;
        color: rgba(62, 113, 255, 1);
        border: 1px solid #3e71ff;
        cursor: pointer;
      }
      .btn-detail:hover {
        background: rgba(62, 113, 255, 1);
        box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
        color: rgba(255, 255, 255, 1);
        border: 1px solid rgba(62, 113, 255, 0.2);
      }
    }
  }
  .navagation {
    background-color: #fff;
    .content__box {
      width: 100%;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .nav__item {
        width: 260px;
        height: 62px;
        font-size: 16px;
        font-weight: 400;
        line-height: 62px;
        color: rgba(41, 43, 58, 1);
        cursor: pointer;
      }
    }
    .isFixed {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 11;
    }
  }
  .product {
    background-color: rgba(248, 250, 253, 1);
    .content__box {
      .product__title {
        padding-top: 80px;
        padding-bottom: 40px;
        font-size: 30px;
        font-weight: bold;
        line-height: 42px;
        color: rgba(41, 43, 58, 1);
        opacity: 1;
      }
      .product__detail {
        padding-bottom: 500px;
        background-position: top center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url("../../assets/img/programme/2527@2x.png");
      }
    }
  }
  .scene {
    background-color: rgba(210, 183, 183, 1);
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../assets/img/programme/210@2x.png");
    .scene__box {
      padding-bottom: 79px;
      .scene__title {
        padding-top: 120px;
        padding-bottom: 90px;
        font-size: 30px;
        font-weight: bold;
        line-height: 42px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
      .scene__detail {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .left {
          width: 200px;
          border-right: 1px solid rgba(255, 255, 255, 0.2);
          .item {
            height: 68px;
            display: flex;
            justify-content: center;
            align-items: center;
            .text {
              font-size: 16px;
              font-weight: 400;
              line-height: 26px;
              color: rgba(255, 255, 255, 0.5);
              opacity: 1;
              cursor: pointer;
            }
            .text-active {
              box-sizing: border-box;
              display: inline-block;
              width: 100%;
              border-right: solid #3e71ff 6px;
              color: rgba(255, 255, 255, 1);
            }
          }
        }
        .right {
          flex: 1;
          margin-left: 50px;
          .item {
            .name {
              padding-top: 8px;
              padding-bottom: 12px;
              font-size: 22px;
              font-weight: bold;
              line-height: 30px;
              color: rgba(255, 255, 255, 1);
              border-bottom: 1px solid rgba(255, 255, 255, 0.2);
              text-align: left;
            }
            .qAndp {
              padding-top: 36px;
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              text-align: left;
              .qbox {
                width: 484px;
                .qtitle {
                  padding-bottom: 20px;
                  font-size: 16px;
                  font-weight: bold;
                  line-height: 22px;
                  color: rgba(255, 255, 255, 1);
                }
                .qitem {
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 26px;
                  color: rgba(255, 255, 255, 0.8);
                  margin-bottom: 12px;
                  position: relative;
                }
                .qitem:before {
                  display: inline-block;
                  content: "";
                  width: 4px;
                  height: 4px;
                  background: rgba(255, 255, 255, 1);
                  border-radius: 50%;
                  opacity: 0.8;
                  position: absolute;
                  left: -10px;
                  top: 50%;
                  transform: translateY(-50%);
                }
              }
              .pbox {
                flex: 1;
                .ptitle {
                  padding-bottom: 20px;
                  font-size: 16px;
                  font-weight: bold;
                  line-height: 22px;
                  color: rgba(255, 255, 255, 1);
                }
                .pitem {
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 26px;
                  color: rgba(255, 255, 255, 0.8);
                  margin-bottom: 12px;
                  position: relative;
                }
                .pitem:before {
                  display: inline-block;
                  content: "";
                  width: 4px;
                  height: 4px;
                  background: rgba(255, 255, 255, 1);
                  border-radius: 50%;
                  opacity: 0.8;
                  position: absolute;
                  left: -10px;
                  top: 14px;
                  transform: translateY(-50%);
                }
                .pway {
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 26px;
                  color: rgba(255, 255, 255, 0.8);
                  padding-top: 8px;
                  padding-bottom: 40px;
                }
                .related {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .related__item {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                    color: rgba(255, 255, 255, 0.8);
                    margin-right: 30px;
                    .item__icon {
                      display: inline-block;
                      width: 32px;
                      height: 32px;
                      background-position: top center;
                      background-repeat: no-repeat;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }
                    .item__icon01 {
                      background-image: url("../../assets/img/programme/480@2x.png");
                    }
                    .item__icon02 {
                      background-image: url("../../assets/img/programme/477@2x.png");
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .advantage {
    padding-bottom: 80px;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    background-image: url("../../assets/img/programme/2518@2x.png");
    .content__box {
      .advantage__title {
        padding-top: 119px;
        padding-bottom: 35px;
        font-size: 30px;
        font-weight: bold;
        line-height: 42px;
        color: rgba(41, 43, 58, 1);
        opacity: 1;
      }
      .advantage__detail {
        .card {
          width: 1020px;
          margin: 0 auto;
          padding: 0 20px;
          .el-carousel__item {
            .card__bdground,
            .card__bdground2 {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background-repeat: no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              z-index: -1;
              filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
              animation: play 8s linear infinite;
            }
            .card__bdground {
              background-image: url("../../assets/img/programme/2520@2x.png");
            }
            .card__bdground2 {
              background-image: url("../../assets/img/programme/2535.png");
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.motherAndInfant .advantage__detail .card .el-carousel__arrow--left {
  left: 0px;
  display: none;
}
.motherAndInfant .advantage__detail .card .el-carousel__arrow--right {
  right: 0px;
  display: none;
}
.motherAndInfant
  .advantage__detail
  .el-carousel__indicator
  .el-carousel__button {
  width: 80px;
  height: 2px;
  background: rgba(207, 213, 226, 1);
}
.motherAndInfant
  .advantage__detail
  .el-carousel__indicator.is-active
  .el-carousel__button {
  background: rgba(62, 113, 255, 1);
}
</style>
